import React from "react";

export default function Hero() {
  return (
    <section id="hero">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Hey, I'm Sasini.
            <br className="hidden lg:inline-block" />I love doing what I do.
          </h1>
          <p className="mb-8 leading-relaxed">
          I am an enthusiastic, self-motivated, reliable, responsible, and hard-working 
          person. Also a good team worker and adaptable to all challenging situations.
          </p>
          <div className="flex justify-center">
            <a
              href="#projects"
              className="inline-flex text-white bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 hover:from-pink-500 hover:to-purple-600 border-0 py-2 px-6 focus:outline-none rounded-3xl text-lg ">
               My Projects            
            </a>
            <a
              href="#contact"
              className="transition duration-500 ease-in-out ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded-3xl text-lg">              Work With Me
            </a>
           
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            // className="object-cover object-center rounded animate-pulse"
            className="object-cover object-center rounded"
            alt="hero"
            src="./proud-girl.svg"
          />
        </div>
      </div>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/components/Hero.js